import * as identify from "utils/treeUtils";
import type { Node } from "interfaces/schemas";

export const isDragDisabled = (node: Node): boolean =>
  identify.isTroxNetcom(node) ||
  identify.isWizard(node) ||
  identify.isProductAccessory(node);
